<template>
  <div class="card modal-card is-min-width-500 width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('detailClient.popupBlocage.title', { nomCommercial: tiers.nomCommercial }) }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                      :error="error"
                      :messagesChampsVide="messagesChampsVide"
                      :champsVide="champsVide"
                      :title="'editionClient.problemOccurred'"
                      :withEmplyFields="true"
                      @close="error = $event"/>
        <div class="columns mgt-20px">
          <b-field :label="$t('detailClient.popupBlocage.level')"
              class="column is-6 obligatoire">
            <b-select expanded v-model="level" >
              <option v-for="level in levels"
                :key="level.key"
                :value="level.key">
                {{$t(level.libelle)}}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t('detailClient.popupBlocage.dateBlocage')"
                  class="column is-6 obligatoire">
            <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          position="is-bottom-left"
                          v-model="dateBlocage"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="columns mgt-20px">
          <b-field :label="$t('detailClient.popupBlocage.commentaires')"
                  class="column is-12">
            <b-input type="textarea" v-model="commentaires"></b-input>
          </b-field>
        </div>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="appliquer()">
                {{ $t('general.button.appliquer') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LIBRE,
  LEVEL_BLOCAGE,
} from '@/configuration/tiers/levelBlocage';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { bloquer } from '@/api/tiers/index';
import formatDate from '@/services/general/formatIsoDate';
import messageSuccess from '@/services/general/messageSucces';
import moment from 'moment';

export default {
  name: 'popupLevelBlocage',
  components: {
    errorMsgComponent,
  },
  props: {
    tiers: {
      type: Object,
      required: true,
    },
    unlock: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      dateBlocage: new Date(),
      level: LIBRE,
      levels: LEVEL_BLOCAGE,
      commentaires: '',
    };
  },
  methods: {
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.message = [];
        this.messagesChampsVide = [];

        const dto = {
          id: this.tiers.id,
          dateBlocageLevel: formatDate(this.dateBlocage),
          blocageLevel: this.level,
          descriptionBlocage: this.commentaires,
        };
        await bloquer(dto);

        loadingComponent.close();
        messageSuccess(this.$i18n.t('detailClient.popupBlocage.success'));
        this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
    },
  },
  mounted() {
    if (this.unlock !== undefined && this.unlock === true) {
      this.level = LIBRE;
      this.commentaires = '';
    } else {
      if (this.tiers.dateBlocageLevel !== undefined && this.tiers.dateBlocageLevel !== null) {
        this.dateBlocage = moment(this.tiers.dateBlocageLevel).toDate();
      }
      this.level = this.tiers.blocageLevel;
      this.commentaires = this.tiers.descriptionBlocage;
    }
  },
};
</script>

<style>

</style>
